import { Monitor, Moon, Sun } from 'lucide-react';

import { definirTema, type PreferenciaTema, usePreferenciaTema } from '@/lib/tema';
import { Button } from '@/ui/primitives/button';

const PROXIMO: Record<PreferenciaTema, PreferenciaTema> = {
  sistema: 'claro',
  claro: 'escuro',
  escuro: 'sistema',
};
const ROTULO: Record<PreferenciaTema, string> = {
  sistema: 'Tema do sistema',
  claro: 'Tema claro',
  escuro: 'Tema escuro',
};

/** Alterna sistema → claro → escuro. O ícone mostra o tema atual. */
export function AlternarTema() {
  const preferencia = usePreferenciaTema();
  const Icone = preferencia === 'claro' ? Sun : preferencia === 'escuro' ? Moon : Monitor;
  return (
    <Button
      variante="fantasma"
      tamanho="icone"
      onClick={() => {
        definirTema(PROXIMO[preferencia]);
      }}
      aria-label={`${ROTULO[preferencia]} (clique para trocar)`}
      title={ROTULO[preferencia]}
    >
      <Icone aria-hidden key={preferencia} className="animate-surgir" />
    </Button>
  );
}
